module.exports = __webpack_public_path__ + "static/img/hongjiu.178e188a.png";